import { scroller } from 'react-scroll';

import parseValidationResult from 'src/app/utils/parseValidationResult';
import type { ValidationResultType } from 'src/types/validation';

interface ContainerComponent {
  components: ValidatableComponent[];
  validationCondition?: () => boolean;
  containerId: string;
}

interface ValidatableComponent {
  current: {
    handleValidation: (skipIfNull?: boolean) => ValidationResultType;
  };
}

export default (
  containerComponentList: null | ContainerComponent[],
  skipIfNull = false,
): string[] => {
  if (!containerComponentList || containerComponentList.length === 0) {
    return [];
  }

  const errorMessages: string[] = [];
  const invalidContainers: ContainerComponent[] = [];

  containerComponentList.forEach((container) => {
    if (
      typeof container.validationCondition !== 'function' ||
      container.validationCondition()
    ) {
      const containerErrorMessages: string[] = [];
      container.components.forEach((component) => {
        if (component.current) {
          const validationResult =
            component.current.handleValidation(skipIfNull);
          containerErrorMessages.push(
            ...parseValidationResult(validationResult).errorMessages,
          );
        }
      });
      if (containerErrorMessages.length > 0) {
        invalidContainers.push(container);
        errorMessages.push(...containerErrorMessages);
      }
    }
  });

  if (invalidContainers.length === 0) {
    return [];
  }
  scroller.scrollTo(invalidContainers[0].containerId, {
    duration: 500,
    delay: 100,
    smooth: true,
  });

  return errorMessages;
};
